// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"407":"e6093c38","436":"b869e4ce","453":"f394a27d","501":"5497c4fd","606":"58ca88ec","925":"24a82157"}[chunkId] + ".chunk.js";
};